var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"category"},[_c('div',{staticClass:"col-12"},[(_vm.loading)?_c('Spinner'):_c('items-grid',{attrs:{"products":_vm.products,"type":"grid"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }